var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"MainContentsArea js_min-height"},[_c('q-loader',{attrs:{"is-show":_vm.isLoading}},[_c('span',[_vm._v(" now loading... ")])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }